import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import mission       from './asset/image/mission.jpg';
import CampusImg from './asset/image/campus.jpg';
import faculty       from './asset/image/faculty.jpg';
import joinUs        from './asset/image/join-us.jpg';
import img02  from './asset/image/img02.jpg';
import img03  from './asset/image/img03.jpg';
import img04  from './asset/image/img04.jpg';
import img05  from './asset/image/img05.jpg';
import img06  from './asset/image/img06.jpg';
import img07  from './asset/image/img07.jpg';
import img08  from './asset/image/img08.jpg';
import img09  from './asset/image/img09.jpg';
import img10  from './asset/image/img10a.jpg';
import img11  from './asset/image/img11a.jpg';
import img12  from './asset/image/img12a.jpg';
import img13  from './asset/image/img13a.jpg';
import img14a from './asset/image/img14a.jpg';
import img15  from './asset/image/img15.jpg';
import img16  from './asset/image/img16.jpg';
import img17  from './asset/image/img17.jpg';
import img18  from './asset/image/img18.jpg';
import img19  from './asset/image/img19.jpg';
import img20  from './asset/image/img20.jpg';
import img21  from './asset/image/img21.jpg';
import img22  from './asset/image/img22.jpg';
import img23  from './asset/image/img23.jpg';
import img24  from './asset/image/img24.jpg';
import img25  from './asset/image/img25.jpg';
import ceoImg       from "./asset/image/ceo.jpg";
import directorImg  from "./asset/image/director.jpg";
import founderImg   from "./asset/image/hero1.jpg";
import mamAnum      from "./asset/image/mamAnum.jpg";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;900&family=DM+Sans:wght@300;400;500;600&display=swap');

:root {
  --navy:#0A1931; --blue:#1A3A6E; --gold:#C9A84C; --gold-lt:#E8C97A;
  --light:#F7F9FC; --white:#FFFFFF; --gray:#6B7A99; --gray-lt:#EEF2F8;
}

.aqk-about *, .aqk-about *::before, .aqk-about *::after { box-sizing:border-box; margin:0; padding:0; }
.aqk-about { font-family:'DM Sans',sans-serif; color:var(--navy); background:#fff; }

/* ── HERO ── */
.aqk-hero {
  position:relative; min-height:92vh;
  display:flex; align-items:center; overflow:hidden;
  background:var(--navy);
}
.aqk-hero-bg {
  position:absolute; inset:0;
  background:linear-gradient(135deg,#0A1931 0%,#112550 60%,#0e1e40 100%);
}
.aqk-hero-bg::before {
  content:''; position:absolute; inset:0;
  background-image:radial-gradient(circle at 20% 50%,rgba(201,168,76,.12) 0%,transparent 50%),
                   radial-gradient(circle at 80% 20%,rgba(26,58,110,.6) 0%,transparent 40%);
}
.aqk-hero-grid {
  position:absolute; inset:0;
  background-image:linear-gradient(rgba(201,168,76,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(201,168,76,.06) 1px,transparent 1px);
  background-size:60px 60px;
}
.aqk-hero-content {
  position:relative; z-index:2;
  max-width:1200px; margin:0 auto; padding:80px 40px;
  display:grid; grid-template-columns:1fr 1fr; gap:80px; align-items:center;
}
@media(max-width:900px){ .aqk-hero-content{grid-template-columns:1fr;gap:40px;padding:60px 24px;} .aqk-hero-visual{display:none;} }
.aqk-hero-eyebrow { display:inline-flex; align-items:center; gap:10px; font-size:11px; font-weight:600; letter-spacing:3px; text-transform:uppercase; color:var(--gold); margin-bottom:24px; }
.aqk-hero-eyebrow::before { content:''; display:block; width:32px; height:2px; background:var(--gold); }
.aqk-hero h1 { font-family:'Playfair Display',serif; font-size:clamp(42px,6vw,72px); font-weight:900; line-height:1.08; color:#fff; margin-bottom:24px; }
.aqk-hero h1 span { color:var(--gold); }
.aqk-hero-desc { font-size:17px; line-height:1.8; color:rgba(255,255,255,.65); max-width:480px; margin-bottom:40px; }
.aqk-hero-stats { display:flex; gap:40px; }
.aqk-hero-stat { text-align:center; }
.aqk-hero-stat-num { font-family:'Playfair Display',serif; font-size:36px; font-weight:700; color:var(--gold); display:block; }
.aqk-hero-stat-lbl { font-size:11px; letter-spacing:1.5px; text-transform:uppercase; color:rgba(255,255,255,.5); }
.aqk-hero-card { background:rgba(255,255,255,.06); border:1px solid rgba(201,168,76,.2); border-radius:20px; padding:32px; backdrop-filter:blur(12px); }
.aqk-hero-card-title { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:#fff; margin-bottom:20px; }
.aqk-hero-badge { display:inline-block; background:rgba(201,168,76,.15); border:1px solid rgba(201,168,76,.4); color:var(--gold-lt); font-size:12px; font-weight:500; padding:6px 14px; border-radius:100px; margin:4px; }
.aqk-hero-divider { width:40px; height:3px; background:var(--gold); border-radius:2px; margin:20px 0; }
.aqk-hero-location { font-size:13px; color:rgba(255,255,255,.5); display:flex; align-items:center; gap:6px; }

/* ── SHARED SECTION ── */
.aqk-section { padding:100px 40px; }
@media(max-width:768px){ .aqk-section{padding:60px 20px;} }
.aqk-container { max-width:1200px; margin:0 auto; }
.aqk-section-label { font-size:11px; font-weight:600; letter-spacing:3px; text-transform:uppercase; color:var(--gold); display:flex; align-items:center; gap:10px; margin-bottom:14px; }
.aqk-section-label::before { content:''; display:block; width:24px; height:2px; background:var(--gold); }
.aqk-section-title { font-family:'Playfair Display',serif; font-size:clamp(32px,4vw,48px); font-weight:700; line-height:1.15; color:var(--navy); margin-bottom:16px; }
.aqk-section-desc { font-size:17px; line-height:1.8; color:var(--gray); max-width:560px; margin-bottom:60px; }

/* ── INTRO ── */
.aqk-intro { background:#fff; }
.aqk-intro-grid { display:grid; grid-template-columns:1fr 1fr; gap:80px; align-items:center; }
@media(max-width:900px){ .aqk-intro-grid{grid-template-columns:1fr;gap:40px;} }
.aqk-intro-img { position:relative; }
.aqk-intro-img img { width:100%; border-radius:16px; box-shadow:0 30px 80px rgba(10,25,49,.15); display:block; }
.aqk-intro-img::before { content:''; position:absolute; top:-16px; left:-16px; right:16px; bottom:16px; border:2px solid var(--gold); border-radius:16px; opacity:.4; }
.aqk-intro-quote { position:absolute; bottom:-20px; right:-20px; background:var(--navy); color:var(--gold); padding:20px 24px; border-radius:12px; font-family:'Playfair Display',serif; font-size:14px; font-style:italic; max-width:200px; line-height:1.5; box-shadow:0 12px 40px rgba(10,25,49,.3); }
.aqk-intro-text .aqk-section-desc { max-width:100%; }
.aqk-highlight { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-top:32px; }
.aqk-highlight-item { display:flex; align-items:flex-start; gap:12px; padding:16px; background:var(--gray-lt); border-radius:12px; border-left:3px solid var(--gold); }
.aqk-highlight-icon { font-size:20px; }
.aqk-highlight-text { font-size:14px; font-weight:500; color:var(--navy); line-height:1.5; }

/* ── MISSION / VISION / VALUES ── */
.aqk-mvv { background:var(--navy); }
.aqk-mvv .aqk-section-title { color:#fff; }
.aqk-mvv .aqk-section-desc { color:rgba(255,255,255,.6); }
.aqk-mvv-cards { display:grid; grid-template-columns:repeat(3,1fr); gap:24px; }
@media(max-width:900px){ .aqk-mvv-cards{grid-template-columns:1fr;} }
.aqk-mvv-card { background:rgba(255,255,255,.05); border:1px solid rgba(201,168,76,.2); border-radius:20px; padding:40px 32px; position:relative; overflow:hidden; transition:transform .3s,background .3s; }
.aqk-mvv-card:hover { transform:translateY(-6px); background:rgba(255,255,255,.08); }
.aqk-mvv-card::before { content:''; position:absolute; top:0; left:0; right:0; height:3px; background:linear-gradient(90deg,var(--gold),var(--gold-lt)); }
.aqk-mvv-num { font-family:'Playfair Display',serif; font-size:64px; font-weight:900; color:rgba(201,168,76,.12); line-height:1; margin-bottom:-16px; }
.aqk-mvv-icon { font-size:32px; margin-bottom:16px; }
.aqk-mvv-title { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:#fff; margin-bottom:14px; }
.aqk-mvv-text { font-size:15px; line-height:1.8; color:rgba(255,255,255,.6); }
.aqk-mvv-values { margin-top:12px; display:flex; flex-wrap:wrap; gap:8px; }
.aqk-mvv-value-tag { font-size:12px; font-weight:500; color:var(--gold); border:1px solid rgba(201,168,76,.3); padding:4px 12px; border-radius:100px; }

/* ── FACILITIES ── */
.aqk-facilities { background:var(--light); }
.aqk-facilities-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:24px; }
@media(max-width:900px){ .aqk-facilities-grid{grid-template-columns:1fr 1fr;} }
@media(max-width:600px){ .aqk-facilities-grid{grid-template-columns:1fr;} }
.aqk-facility-card { background:#fff; border-radius:16px; padding:32px; box-shadow:0 4px 24px rgba(10,25,49,.06); transition:transform .3s,box-shadow .3s,border-color .3s; border-bottom:3px solid transparent; border:1px solid var(--gray-lt); }
.aqk-facility-card:hover { transform:translateY(-6px); box-shadow:0 20px 60px rgba(10,25,49,.12); border-bottom-color:var(--gold); }
.aqk-facility-icon { width:56px; height:56px; background:linear-gradient(135deg,var(--navy),var(--blue)); border-radius:14px; display:flex; align-items:center; justify-content:center; font-size:24px; margin-bottom:20px; }
.aqk-facility-title { font-family:'Playfair Display',serif; font-size:18px; font-weight:700; color:var(--navy); margin-bottom:10px; }
.aqk-facility-text { font-size:14px; line-height:1.7; color:var(--gray); }
.aqk-facility-img-wrap { border-radius:16px; overflow:hidden; box-shadow:0 20px 60px rgba(10,25,49,.12); margin-bottom:40px; }
.aqk-facility-img-wrap img { width:100%; height:340px; object-fit:cover; display:block; }

/* ── FACULTY ── */
.aqk-faculty { background:#fff; }
.aqk-faculty-layout { display:grid; grid-template-columns:1fr 1fr; gap:80px; align-items:center; }
@media(max-width:900px){ .aqk-faculty-layout{grid-template-columns:1fr;gap:40px;} }
.aqk-faculty-img img { width:100%; border-radius:16px; box-shadow:0 30px 80px rgba(10,25,49,.15); display:block; }
.aqk-faculty-points { list-style:none; margin-top:32px; }
.aqk-faculty-points li { display:flex; align-items:center; gap:14px; padding:14px 0; border-bottom:1px solid var(--gray-lt); font-size:15px; color:var(--navy); }
.aqk-faculty-points li::before { content:'✓'; width:26px; height:26px; background:var(--gold); color:var(--navy); border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:12px; font-weight:700; flex-shrink:0; }

/* ── LEADERSHIP ON ABOUT PAGE ── */
.aqk-leadership { background:var(--light); }
.aqk-leader-cards { display:grid; grid-template-columns:repeat(3,1fr); gap:28px; }
@media(max-width:900px){ .aqk-leader-cards{grid-template-columns:1fr;} }
.aqk-leader-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 8px 40px rgba(10,25,49,.08); transition:transform .3s,box-shadow .3s; border:1px solid var(--gray-lt); }
.aqk-leader-card:hover { transform:translateY(-8px); box-shadow:0 24px 80px rgba(10,25,49,.15); }
.aqk-leader-header { position:relative; background:linear-gradient(135deg,var(--navy),var(--blue)); padding:32px 24px 20px; text-align:center; }
.aqk-leader-header::after { content:''; position:absolute; bottom:-1px; left:0; right:0; height:40px; background:#fff; clip-path:ellipse(55% 100% at 50% 100%); }
.aqk-leader-img { width:96px; height:96px; border-radius:50%; border:4px solid var(--gold); object-fit:cover; display:block; margin:0 auto 14px; position:relative; z-index:1; }
.aqk-leader-name { font-family:'Playfair Display',serif; font-size:16px; font-weight:700; color:#fff; position:relative; z-index:1; }
.aqk-leader-role { font-size:11px; letter-spacing:2px; text-transform:uppercase; color:var(--gold); margin-top:4px; position:relative; z-index:1; }
.aqk-leader-body { padding:28px 24px 24px; }
.aqk-leader-quote { font-size:14px; line-height:1.8; color:var(--gray); font-style:italic; margin-bottom:20px; padding-left:16px; border-left:3px solid var(--gold); }
.aqk-leader-btn { display:inline-flex; align-items:center; gap:6px; font-size:13px; font-weight:600; color:var(--navy); background:none; border:none; cursor:pointer; padding:0; transition:color .2s; font-family:'DM Sans',sans-serif; }
.aqk-leader-btn:hover { color:var(--gold); }

/* ── GALLERY ── */
.aqk-gallery { background:var(--navy); }
.aqk-gallery .aqk-section-title { color:#fff; }
.aqk-gallery .aqk-section-desc { color:rgba(255,255,255,.6); }
.aqk-gallery-tabs { display:flex; flex-wrap:wrap; gap:10px; margin-bottom:36px; }
.aqk-gallery-tab { padding:10px 22px; border-radius:100px; border:1px solid rgba(201,168,76,.3); background:transparent; color:rgba(255,255,255,.6); font-size:13px; font-weight:500; cursor:pointer; transition:all .2s; font-family:'DM Sans',sans-serif; }
.aqk-gallery-tab.active,.aqk-gallery-tab:hover { background:var(--gold); color:var(--navy); border-color:var(--gold); font-weight:600; }
.aqk-gallery-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:12px; }
@media(max-width:900px){ .aqk-gallery-grid{grid-template-columns:repeat(2,1fr);} }
@media(max-width:500px){ .aqk-gallery-grid{grid-template-columns:1fr 1fr;} }
.aqk-gallery-item { aspect-ratio:1; border-radius:12px; overflow:hidden; position:relative; }
.aqk-gallery-item img { width:100%; height:100%; object-fit:cover; transition:transform .4s ease; display:block; }
.aqk-gallery-item:hover img { transform:scale(1.08); }
.aqk-gallery-item-overlay { position:absolute; inset:0; background:linear-gradient(to top,rgba(10,25,49,.7) 0%,transparent 50%); opacity:0; transition:opacity .3s; }
.aqk-gallery-item:hover .aqk-gallery-item-overlay { opacity:1; }

/* ── JOIN US ── */
.aqk-join { background:linear-gradient(135deg,var(--navy) 0%,#112550 100%); position:relative; overflow:hidden; }
.aqk-join::before { content:''; position:absolute; inset:0; background-image:radial-gradient(circle at 70% 50%,rgba(201,168,76,.1) 0%,transparent 50%); }
.aqk-join-layout { display:grid; grid-template-columns:1fr 1fr; gap:80px; align-items:center; position:relative; z-index:1; }
@media(max-width:900px){ .aqk-join-layout{grid-template-columns:1fr;gap:40px;} }
.aqk-join .aqk-section-title { color:#fff; }
.aqk-join .aqk-section-desc { color:rgba(255,255,255,.65); max-width:100%; }
.aqk-join-img img { width:100%; border-radius:16px; box-shadow:0 30px 80px rgba(0,0,0,.3); display:block; }
.aqk-join-actions { display:flex; gap:16px; flex-wrap:wrap; margin-top:36px; }
.aqk-btn-primary { display:inline-flex; align-items:center; gap:8px; background:var(--gold); color:var(--navy); font-weight:700; font-size:15px; padding:16px 32px; border-radius:100px; text-decoration:none; border:none; cursor:pointer; transition:background .2s,transform .2s; font-family:'DM Sans',sans-serif; }
.aqk-btn-primary:hover { background:var(--gold-lt); transform:translateY(-2px); }
.aqk-btn-outline { display:inline-flex; align-items:center; gap:8px; background:transparent; color:#fff; font-weight:600; font-size:15px; padding:16px 32px; border-radius:100px; border:2px solid rgba(255,255,255,.3); text-decoration:none; cursor:pointer; transition:border-color .2s,color .2s; font-family:'DM Sans',sans-serif; }
.aqk-btn-outline:hover { border-color:var(--gold); color:var(--gold); }

/* ── FOOTER ── */
.aqk-footer { background:#060f1e; padding:60px 40px 30px; }
.aqk-footer-inner { max-width:1200px; margin:0 auto; display:grid; grid-template-columns:2fr 1fr 1fr; gap:60px; padding-bottom:48px; border-bottom:1px solid rgba(255,255,255,.08); }
@media(max-width:768px){ .aqk-footer-inner{grid-template-columns:1fr;gap:36px;} }
.aqk-footer-brand-name { font-family:'Playfair Display',serif; font-size:20px; font-weight:700; color:#fff; margin-bottom:12px; }
.aqk-footer-brand-desc { font-size:14px; color:rgba(255,255,255,.45); line-height:1.7; margin-bottom:24px; }
.aqk-footer-social { display:flex; gap:12px; }
.aqk-footer-social-btn { width:36px; height:36px; border:1px solid rgba(255,255,255,.15); border-radius:50%; display:flex; align-items:center; justify-content:center; color:rgba(255,255,255,.5); text-decoration:none; font-size:14px; transition:border-color .2s,color .2s; }
.aqk-footer-social-btn:hover { border-color:var(--gold); color:var(--gold); }
.aqk-footer-col-title { font-size:12px; font-weight:600; letter-spacing:2px; text-transform:uppercase; color:var(--gold); margin-bottom:20px; }
.aqk-footer-links { list-style:none; display:flex; flex-direction:column; gap:10px; }
.aqk-footer-links a { font-size:14px; color:rgba(255,255,255,.5); text-decoration:none; transition:color .2s; }
.aqk-footer-links a:hover { color:var(--gold-lt); }
.aqk-footer-bottom { max-width:1200px; margin:0 auto; padding-top:28px; display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:12px; }
.aqk-footer-copy { font-size:12px; color:rgba(255,255,255,.25); }
.aqk-footer-credit {
  font-size:12px; font-style:italic; color:var(--gold);
  letter-spacing:.5px; display:inline-flex; align-items:center; gap:6px;
}
.aqk-footer-credit::before { content:'✦'; font-style:normal; font-size:10px; color:rgba(201,168,76,.5); }

/* ── SCROLL FADE ── */
.aqk-fade { opacity:0; transform:translateY(30px); transition:opacity .6s ease,transform .6s ease; }
.aqk-fade.visible { opacity:1; transform:translateY(0); }
`;

const useFadeIn = () => {
  useEffect(() => {
    const els = document.querySelectorAll('.aqk-fade');
    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target); } }),
      { threshold:0.12 }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);
};

const facilitiesData = [
  {  title:'Modern Laboratories',  text:'State-of-the-art science labs equipped with contemporary instruments for practical learning.' },
  { title:'Resource Library',      text:'A comprehensive library with thousands of books, journals, and digital resources.' },
  { title:'Computer Lab',          text:'Well-equipped computing facilities for ICS students and digital learning across all programs.' },
  {  title:'Sports Facilities',     text:'Football ground, indoor games, and open areas promoting physical wellness.' },
  { title:'Auditorium',            text:'A modern auditorium for ceremonies, seminars, and student performances.' },
  { title:'Safe Environment',      text:'CCTV monitoring, disciplined campus, and a zero-tolerance policy for misconduct.' },
];

const galleryCategories = [
  { label:'Student Trips',     images:[img06,img07,img08,img09] },
  { label:'Career Counseling', images:[img02,img03,img04,img05] },
  { label:'Iqbal Day',         images:[img10,img11,img12,img13] },
  { label:'Parents Meeting',   images:[img14a,img15,img16,img17] },
  { label:'Sports Events',     images:[img18,img19,img20,img21] },
  { label:'Orientation',       images:[img22,img23,img24,img25] },
];


const messages = [
  {
    id:'founder',
    title:'Founder ',
    role:'Dr. Abdul Qadeer Khan',
    img:founderImg,
    short:'His vision was to ensure that every Pakistani child has access to world-class education — the true foundation of national strength.',
    full:'Dr. Abdul Qadeer Khan was not only a scientist of extraordinary stature but a man whose heart beat for Pakistan. His dream was simple yet profound: to ensure that every Pakistani child has access to world-class education — the true foundation of national strength.\n\nHis vision in establishing this institution was to create a place where young minds are not just taught, but inspired. Where knowledge meets character, and where students leave not only as scholars but as responsible citizens ready to serve their nation.\n\nHis legacy lives on in every student who walks these halls, in every teacher who imparts wisdom, and in every family whose child\'s future is brighter because of this college.',
  },
  {
    id:'ceo',
    title:'Director',
    role:'Director',
    img:directorImg,
    short:'We are dedicated to revolutionizing education beyond boundaries, fostering creativity, confidence, and holistic growth.',
    full:'At Dr. AQ Khan College, we are dedicated to revolutionizing the dynamics of the education sector, where education thrives beyond boundaries. We foster creativity, confidence, and holistic growth in our students. Our aim is to develop well-rounded individuals empowering them with purpose, integrity, and social responsibility.',
  },
  {
    id:'principal',
    title:"Principal",
    role:'Mam Anum',
    img:mamAnum,
    short:'Education without character is incomplete. We nurture every student not just academically but as a complete human being.',
    full:"Education without character is incomplete. That is the philosophy that drives the Board of Governors at Dr. A.Q. Khan College, and it is the philosophy I carry in every decision I make on behalf of our students.\n\nWe are working tirelessly to improve student support systems, enhance our co-curricular activities, and ensure that every student — regardless of background — has access to the best education possible.\n\nThis institution is more than a college. It is a community, and I am honoured to serve it.",
  },
];

const About = () => {
  const [activeCategory, setActiveCategory] = useState(0);
  const [expandedMsg, setExpandedMsg]       = useState(null);
  useFadeIn();

  return (
    <>
      <style>{css}</style>
      <div className="aqk-about">

        {/* ── 1. HERO ── */}
        <section className="aqk-hero">
          <div className="aqk-hero-bg" />
          <div className="aqk-hero-grid" />
          <div className="aqk-hero-content">
            <div>
              <div className="aqk-hero-eyebrow">Rawalpindi · Since 2010</div>
              <h1>Excellence in<br /><span>Science &</span><br />Technology</h1>
              <p className="aqk-hero-desc">Dr. A.Q. Khan College of Science and Technology — Harley Street, Rawalpindi, dedicated to shaping the innovators and leaders of tomorrow.</p>
              <div className="aqk-hero-stats">
                <div className="aqk-hero-stat"><span className="aqk-hero-stat-num">8+</span><span className="aqk-hero-stat-lbl">Programs</span></div>
                <div className="aqk-hero-stat"><span className="aqk-hero-stat-num">6</span><span className="aqk-hero-stat-lbl">University MOUs</span></div>
                <div className="aqk-hero-stat"><span className="aqk-hero-stat-num">100%</span><span className="aqk-hero-stat-lbl">Dedication</span></div>
              </div>
            </div>
            <div className="aqk-hero-visual">
              <div className="aqk-hero-card">
                <div className="aqk-hero-card-title">Programs Offered</div>
                {['FSc Pre-Medical','FSc Pre-Engineering','ICS','ICOM','FA (IT)','FA (Humanities)'].map(p=>(
                  <span key={p} className="aqk-hero-badge">{p}</span>
                ))}
                <div className="aqk-hero-divider" />
                <div className="aqk-hero-location"> 3 Harley Street, Rawalpindi</div>
                <div className="aqk-hero-location" style={{marginTop:8}}> +92 345 3300699</div>
              </div>
            </div>
          </div>
        </section>

        {/* ── 2. INTRO ── */}
        <section className="aqk-section aqk-intro">
          <div className="aqk-container">
            <div className="aqk-intro-grid">
              <div className="aqk-intro-img aqk-fade">
                <img src={mission} alt="Dr AQ Khan College" />
                <div className="aqk-intro-quote">"Empowering minds, shaping Pakistan's future."</div>
              </div>
              <div className="aqk-intro-text aqk-fade" style={{transitionDelay:'0.15s'}}>
                <div className="aqk-section-label">About the College</div>
                <h2 className="aqk-section-title">A Legacy of Academic Excellence</h2>
                <p className="aqk-section-desc">Located on Harley Street Lane #3 in Rawalpindi, Dr. A.Q. Khan College of Science and Technology is a name synonymous with quality education, character building, and holistic student development.</p>
                <p className="aqk-section-desc" style={{marginTop:-30}}>Named after the legendary Dr. Abdul Qadeer Khan, we carry the spirit of dedication, precision, and national service in everything we do.</p>
                <div className="aqk-highlight">
                  {[{icon:'',text:'FBISE & NAVTTC Affiliated Programs'},{icon:'',text:'MOUs with Riphah,CUST, IST, ATH, BIIT, University of Rawalpindi'},{icon:'',text:'Need & Merit-based Scholarships'},{icon:'',text:'Structured Evaluation System'}].map((h,i)=>(
                    <div key={i} className="aqk-highlight-item"><span className="aqk-highlight-icon">{h.icon}</span><span className="aqk-highlight-text">{h.text}</span></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── 3. MISSION / VISION / VALUES ── */}
        <section className="aqk-section aqk-mvv">
          <div className="aqk-container">
            <div className="aqk-fade">
              <div className="aqk-section-label">Our Foundation</div>
              <h2 className="aqk-section-title">Mission, Vision &amp; Values</h2>
              <p className="aqk-section-desc">The pillars that guide every decision, every lesson, and every student we serve.</p>
            </div>
            <div className="aqk-mvv-cards">
              <div className="aqk-mvv-card aqk-fade">
                <div className="aqk-mvv-num">01</div>
                <div className="aqk-mvv-title">Our Mission</div>
                <p className="aqk-mvv-text">"Dr. A.Q. Khan College" strives to be a unique community where the potential and talent of each individual is realized within a friendly and challenging environment based on Islamic principles.</p>
              </div>
              <div className="aqk-mvv-card aqk-fade" style={{transitionDelay:'0.1s'}}>
                <div className="aqk-mvv-num">02</div>
                <div className="aqk-mvv-title">Our Vision</div>
                <p className="aqk-mvv-text">Our vision concentrates on preparation for life, which involves promoting academic achievement, fostering a responsible and confident self-image in our students, and encouraging a personal commitment to the extended community.</p>
              </div>
              <div className="aqk-mvv-card aqk-fade" style={{transitionDelay:'0.2s'}}>
                <div className="aqk-mvv-num">03</div>
                <div className="aqk-mvv-title">Core Values</div>
                <p className="aqk-mvv-text">Every aspect of our college life is guided by a commitment to integrity, excellence, and responsibility.</p>
                <div className="aqk-mvv-values">
                  {['Integrity','Excellence','Respect','Responsibility','Innovation'].map(v=>(
                    <span key={v} className="aqk-mvv-value-tag">{v}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── 4. FACILITIES ── */}
        <section className="aqk-section aqk-facilities">
          <div className="aqk-container">
            <div className="aqk-fade">
              <div className="aqk-section-label">Infrastructure</div>
              <h2 className="aqk-section-title">World-Class Facilities</h2>
              <p className="aqk-section-desc">Our campus is designed to provide every resource students need to excel academically and grow personally.</p>
            </div>
            <div className="aqk-facility-img-wrap aqk-fade">
              <img src={CampusImg} alt="College Facilities" />
            </div>
            <div className="aqk-facilities-grid">
              {facilitiesData.map((f,i)=>(
                <div key={i} className="aqk-facility-card aqk-fade" style={{transitionDelay:`${i*.08}s`}}>
                  <div className="aqk-facility-title">{f.title}</div>
                  <p className="aqk-facility-text">{f.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── 5. FACULTY ── */}
        <section className="aqk-section aqk-faculty">
          <div className="aqk-container">
            <div className="aqk-faculty-layout">
              <div className="aqk-faculty-img aqk-fade">
                <img src={faculty} alt="Our Faculty" />
              </div>
              <div className="aqk-fade" style={{transitionDelay:'0.15s'}}>
                <div className="aqk-section-label">Our People</div>
                <h2 className="aqk-section-title">Expert Faculty, Dedicated Mentors</h2>
                <p className="aqk-section-desc">Our faculty members are not just teachers — they are industry experts, researchers, and passionate mentors who invest in every student's success.</p>
                <ul className="aqk-faculty-points">
                  {['Highly qualified and experienced educators','Subject matter experts from industry and academia','Personalized mentoring and student support','Regular workshops, seminars, and career counseling','Committed to every student\'s holistic development'].map((point,i)=>(
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        

        {/* ── 7. GALLERY ── */}
        <section className="aqk-section aqk-gallery">
          <div className="aqk-container">
            <div className="aqk-fade">
              <div className="aqk-section-label">Campus Life</div>
              <h2 className="aqk-section-title">Student Life Gallery</h2>
              <p className="aqk-section-desc">Beyond academics — explore the vibrant events, activities, and memories that define life at Dr. A.Q. Khan College.</p>
            </div>
            <div className="aqk-gallery-tabs aqk-fade">
              {galleryCategories.map((cat,i)=>(
                <button key={i} className={`aqk-gallery-tab${activeCategory===i?' active':''}`} onClick={()=>setActiveCategory(i)}>{cat.label}</button>
              ))}
            </div>
            <div className="aqk-gallery-grid">
              {galleryCategories[activeCategory].images.map((img,i)=>(
                <div key={i} className="aqk-gallery-item aqk-fade" style={{transitionDelay:`${i*.03}s`}}>
                  <img src={img} alt={`${galleryCategories[activeCategory].label} ${i+1}`} />
                  <div className="aqk-gallery-item-overlay" />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── 8. JOIN US ── */}
        <section className="aqk-section aqk-join">
          <div className="aqk-container">
            <div className="aqk-join-layout">
              <div className="aqk-fade">
                <div className="aqk-section-label">Admissions Open</div>
                <h2 className="aqk-section-title">Begin Your Journey With Us</h2>
                <p className="aqk-section-desc">Join a community of curious minds and ambitious achievers. Whether you're passionate about science, commerce, or the humanities — Dr. A.Q. Khan College has a place for you.</p>
                <div className="aqk-join-actions">
                  <a href={`${process.env.PUBLIC_URL}/form.pdf`} target="_blank" rel="noopener noreferrer" className="aqk-btn-primary">📄 Get Admission Form</a>
                  <Link to="/contact" className="aqk-btn-outline">📞 Contact Us</Link>
                </div>
              </div>
              <div className="aqk-join-img aqk-fade" style={{transitionDelay:'0.15s'}}>
                <img src={joinUs} alt="Join Dr AQ Khan College" />
              </div>
            </div>
          </div>
        </section>

        {/* ── FOOTER ── */}
        <footer className="aqk-footer">
          <div className="aqk-footer-inner">
            <div>
              <div className="aqk-footer-brand-name">Dr. A.Q. Khan College</div>
              <p className="aqk-footer-brand-desc">A premier institution on Harley Street, Rawalpindi — dedicated to academic excellence, character building, and shaping Pakistan's future leaders.</p>
              <div className="aqk-footer-social">
                <a href="https://www.facebook.com/aqkhancollegeharleycampus/" className="aqk-footer-social-btn" target="_blank" rel="noreferrer">f</a>
                <a href="#" className="aqk-footer-social-btn">tw</a>
                <a href="#" className="aqk-footer-social-btn">in</a>
              </div>
            </div>
            <div>
              <div className="aqk-footer-col-title">Quick Links</div>
              <ul className="aqk-footer-links">
                {[['Home','/'],['About','/about'],['Admissions','/admissions'],['Faculty','/faculty'],['Leadership','/leadership'],['Contact','/contact']].map(([l,p])=>(
                  <li key={p}><Link to={p}>{l}</Link></li>
                ))}
              </ul>
            </div>
            <div>
              <div className="aqk-footer-col-title">Contact</div>
              <ul className="aqk-footer-links">
                <li><a href="#">📍 3 Harley Street, Rawalpindi</a></li>
                <li><a href="tel:+923453300699">📞 +92 345 3300699</a></li>
                <li><a href="mailto:aqkhanedu@gmail.com">✉️ aqkhanedu@gmail.com</a></li>
                <li><a href="#">Mon–Fri: 8 am – 4 pm</a></li>
              </ul>
            </div>
          </div>
          <div className="aqk-footer-bottom">
            <span className="aqk-footer-copy">© 2026 Dr. A.Q. Khan College. All rights reserved.</span>
            <span className="aqk-footer-credit">Designed by Zaib Fatima</span>
          </div>
        </footer>

      </div>
    </>
  );
};

export default About;